import React from "react";
import PageBuilder from "../PageBuilder";
import type { TwoColumnsFields, ACFBuilder } from "@/types/acf";

type Props = {
  data: TwoColumnsFields & { id?: string; hide?: boolean };
};

function hasContentCard(blocks: ACFBuilder[]) {
  return Array.isArray(blocks) && blocks.some((b) => b?.acf_fc_layout === "content_card");
}

export default function TwoColumns({ data }: Props) {
  if (!data?.left_column && !data?.right_column) return null;
  if (data?.hide) return null;

  const leftBlocks = (data.left_column?.left_column ?? []) as ACFBuilder[];
  const rightBlocks = (data.right_column?.right_column ?? []) as ACFBuilder[];

  const hasContent = leftBlocks.length > 0 || rightBlocks.length > 0;
  if (!hasContent) return null;

  // If either side has a ContentCard, we want "top + stretch" behaviour.
  const stretchLeft = hasContentCard(leftBlocks);
  const stretchRight = hasContentCard(rightBlocks);

  return (
    <div className="grid gap-8 lg:grid-cols-2 items-stretch">
      {/* COLUMN 1 */}
      <div className={`min-w-0 flex ${stretchLeft ? "items-stretch" : "items-center"}`}>
        <div
          className={`w-full flex flex-col gap-8 ${
            stretchLeft ? "self-stretch justify-start" : ""
          }`}
        >
          <PageBuilder data={leftBlocks} inColumns />
        </div>
      </div>

      {/* COLUMN 2 */}
      <div className={`min-w-0 flex ${stretchRight ? "items-stretch" : "items-center"}`}>
        <div
          className={`w-full flex flex-col gap-8 ${
            stretchRight ? "self-stretch justify-start" : ""
          }`}
        >
          <PageBuilder data={rightBlocks} inColumns />
        </div>
      </div>
    </div>
  );
}
